import state from './Inquiry/states'
import mutations from './Inquiry/mutations'
import actions from './Inquiry/actions'
import getters from './Inquiry/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
